<div class="row">
    <div class="col-1">
        <app-back-button></app-back-button>
    </div>
    <div class="col">
        <h2 class="h2-responsive text-center">New Client</h2>
    </div>
</div>
<div class="row">
    <mdb-tabset #staticTabs [buttonClass]="'col nav-tabs tabs-3 primary-color'" [contentClass]="'card'" class="col-12">
        <mdb-tab heading="General">
            <form #clientForm="ngForm" class="form-horizontal">
                <div class="form-group">
                    <label class="col-12" for="firstName">
                        <h6><i class="fa fa-user pt-2 pr-2 h4-responsive"></i>First Name*:</h6>
                        
                    </label>
                    <div class="col-12">
                        <input class="form-control" name="firstName" type="text" [(ngModel)]="Client.firstName" 
                        required #firstName="ngModel" />
                    </div>
                    <div *ngIf="firstName.invalid && (firstName.dirty || firstName.touched || clientForm.submitted)"
                        class="alert alert-danger">
                        <div *ngIf="firstName.errors.required">
                            First Name is required.
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-12" for="lastName">
                        <h6><i class="fa fa-user pt-2 pr-2 h4-responsive"></i>Last Name*:</h6>
                        
                    </label>
                    <div class="col-12">
                        <input class="form-control" name="lastName" type="text" [(ngModel)]="Client.lastName" required #lastName="ngModel" />
                    </div>
                    <div *ngIf="lastName.invalid && (lastName.dirty || lastName.touched || clientForm.submitted)"
                        class="alert alert-danger">
                        <div *ngIf="lastName.errors.required">
                            Last Name is required.
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-12" for="uniqueToken">
                        <h6><i class="fa fa-key pt-2 pr-2 h4-responsive"></i>Client Login Identifier**: </h6>
                    </label>
                    <div class="col-12">
                        <h6>
                            <span *ngIf="isGeneratingClientId" class="h4">Generating...</span>
                            <span *ngIf="!isGeneratingClientId" class="h4">{{Client.id}}</span>
                            <input type="button" class="btn btn-primary" value="Generate New Id" (click)="generateClientId()" [disabled]="isGeneratingClientId" />
                            <app-spin-icon *ngIf="isGeneratingClientId"></app-spin-icon>
                        </h6>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-12" for="emailAddress">
                        <h6><i class="fa fa-envelope pt-2 pr-2 h4-responsive"></i>Email*:</h6>
                    </label>
                    <div class="col-12">
                        <input class="form-control" name="emailAddress" type="text" email [(ngModel)]="Client.email" #emailAddress="ngModel" />
                    </div>
                    <div *ngIf="emailAddress.invalid && (emailAddress.dirty || emailAddress.touched || clientForm.submitted)"
                        class="alert alert-danger">
                        <div *ngIf="emailAddress.errors.required">
                            Email is required.
                        </div>
                        <div *ngIf="emailAddress.errors.email">
                                Email must be a valid email address with the local address being shorter than 64 characters and the whole email
                                address less than 254 characters.
                            </div>
                    </div>
                </div>

                <div class="form-group" *hasPermission="'Admin'">
                    <label class="col-12" for="assignedUser"><h6><i class="fa fa-user pt-2 pr-2 h4-responsive red-text"></i>Assigned User</h6></label>
                    <div class="col-12">
                        <user-selector [user]="Client.user" [allowEmpty]="true" (selected)="setUser($event)"></user-selector>
                    </div>
                </div>

                <div *ngIf="showPasswordFields" class="form-group">
                    <label class="col-12" for="password">Client Password:</label>
                    <div class="col-12 ">
                        <input class="form-control" id="password" type="password" [(ngModel)]="password" />
                    </div>
                </div>

                <div *ngIf="showPasswordFields" class="form-group">
                    <label class="col-12" for="confirmPassword">Client Confirm Password:</label>
                    <div class="col-12">
                        <input id="confirmPassword" type="password" class="form-control" [(ngModel)]="confirmPassword" />
                    </div>
                </div>

                <div class="form-group">
                    <div class="col">
                        <input [disabled]="isSaving" class="btn btn-primary" type="button" value="Save" (click)="clientForm.submitted=true;save(clientForm.valid)" />
                    </div>
                </div>
                <div class="col-12 alert alert-info">
                    <p> * This field is required</p>
                    <p>** Your client will use this unique identifier to login.</p>
                </div>
            </form>
        </mdb-tab>
        
    </mdb-tabset>
</div>


// WEBPACK FOOTER //
// ./src/app/admin/client-new/client-new.component.html